module.exports = __webpack_public_path__ + "img/apartment_dialog_icon02.a0ae5156.png";